'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _Heart = require('../generic/Heart');

var _Heart2 = _interopRequireDefault(_Heart);

var _ReOrder = require('./ReOrder');

var _ReOrder2 = _interopRequireDefault(_ReOrder);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrderStatus = function (_React$Component) {
    _inherits(OrderStatus, _React$Component);

    function OrderStatus() {
        _classCallCheck(this, OrderStatus);

        return _possibleConstructorReturn(this, (OrderStatus.__proto__ || Object.getPrototypeOf(OrderStatus)).apply(this, arguments));
    }

    _createClass(OrderStatus, [{
        key: 'getDeliveryAddress',
        value: function getDeliveryAddress() {
            var order = this.props.order;
            var currentUser = _parse2.default.User.current();
            var address = "";

            if (order === null) {
                return "";
            }
            address = currentUser.get("name") + ', ' + order.deliveryAddLine1 + '\n            ' + order.deliveryAddLine2 + ', ' + order.deliveryCity + ', ' + order.deliveryState + ' ' + order.deliveryZip + '\n            ' + Utils.formatPhoneNumber(order.deliveryPhone);

            return address;
        }
    }, {
        key: 'getOrderItemsToPrepStr',
        value: function getOrderItemsToPrepStr(order) {
            if (order.itemsToPrep) {
                return order.itemsToPrep + ' ' + (order.itemsToPrep > 1 ? 'items' : 'item');
            } else if (order.itemCount) {
                return order.itemCount + ' ' + (order.itemCount > 1 ? 'items' : 'item');
            } else {
                return "";
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var self = this;
            var order = this.props.order;

            var dispStr = "";
            var isDeliveryOrder = false;
            var isCurbsidePickupOrder = false;
            var isUtensilsAndNapkins = false;
            var utensilsAndNapkins = "No";
            var vMakeModel = null;
            var vColor = null;

            var isDineInEnabled = false;
            var slData = null;

            var orderTypeStatus = order.orderType;

            if (orderTypeStatus == "Delivery") {
                dispStr = "Deliver To";
                isDeliveryOrder = true;
            }

            if (orderTypeStatus == "PickUp" && !Utils.isEmptyObj(order.curbsidePickup)) {

                // get the screen width and added condition
                var screenWidth = screen.width;
                if (screenWidth > 480) {
                    orderTypeStatus = "Curbside Pickup";
                } else {
                    orderTypeStatus = "Curbside";
                }

                dispStr = "Vehicle Details";
                isCurbsidePickupOrder = true;

                if (order.curbsidePickup && order.curbsidePickup.vMakeModel) {
                    vMakeModel = order.curbsidePickup.vMakeModel;
                }

                if (order.curbsidePickup && order.curbsidePickup.vColor) {
                    vColor = order.curbsidePickup.vColor;
                }
            }

            if (orderTypeStatus == "DineIn" && !Utils.isEmptyObj(order.dineIn)) {

                orderTypeStatus = "Dine In";

                isDineInEnabled = true;

                if (order.dineIn && order.dineIn.serviceLocation) {
                    dispStr = order.dineIn.serviceLocation;
                } else {
                    dispStr = "Table";
                }

                if (order.dineIn && order.dineIn.slData) {
                    slData = order.dineIn.slData;
                } else if (order.dineIn && order.dineIn.tableNumber) {
                    slData = order.dineIn.tableNumber;
                } else {
                    slData = "Not Available";
                }
            }

            /*
            * Check the order extraInfo exist or not
            * */

            if (!Utils.isEmptyObj(order.extraInfo)) {

                var extraInfo = order.extraInfo;
                // check the utensilsAndNapkins key exist or not
                if (Utils.isVariableDefined(extraInfo.utensilsAndNapkins)) {
                    isUtensilsAndNapkins = true;

                    utensilsAndNapkins = extraInfo.utensilsAndNapkins ? "Yes" : "No";
                }
            }

            var itemsToPrepStr = this.getOrderItemsToPrepStr(order);

            var PaymentType = null;

            if (order.chargeId == null) {
                PaymentType = "NO PAYMENT MADE!";
            } else {
                // PaymentType = order.paymentType ? order.paymentType : null;
                PaymentType = !Utils.isEmptyObj(order.paymentDetail) ? order.paymentDetail.paymentType : null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'section order-success-pg' },
                _react2.default.createElement(
                    'div',
                    { className: 'container', style: { maxWidth: '100%' } },
                    _react2.default.createElement(
                        'div',
                        { className: 'row' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12 text-center' },
                            _react2.default.createElement(
                                'h3',
                                { className: "order-heading2" },
                                'Order Status'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'order-success-box' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-md-12 os-det os-green order-heading3' },
                            _react2.default.createElement(
                                'div',
                                { className: 'pull-left' },
                                _react2.default.createElement(
                                    'h2',
                                    { className: "order-status" },
                                    Utils.getOrderStateLabel(order.orderState)
                                ),
                                _react2.default.createElement(
                                    'h4',
                                    { className: "remove-padding remove-margin" },
                                    orderTypeStatus,
                                    ' (',
                                    itemsToPrepStr,
                                    ')'
                                )
                            ),
                            _react2.default.createElement(_ReOrder2.default, {
                                order: order,
                                classNames: "pull-right",
                                locationDetail: this.props.locationDetail
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'container col-md-12 os-det', style: { maxWidth: '100%' } },
                            _react2.default.createElement(
                                'div',
                                { className: 'tot-span' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'row tot-span-box' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'col-xs-12' },
                                        _react2.default.createElement(
                                            'span',
                                            { className: 'lbl1 pull-left' },
                                            'Total: '
                                        ),
                                        _react2.default.createElement(
                                            'span',
                                            {
                                                className: 'price-lbl pull-left' },
                                            ' $',
                                            Utils.toRoundStr(order.totalAmount, 2)
                                        ),
                                        _react2.default.createElement(_Heart2.default, {
                                            isFavorite: order.isFavorite,
                                            orderId: order.objectId,
                                            classNames: "pull-right"
                                        })
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        'Payment:'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        _react2.default.createElement('span', { className: !Utils.isEmptyObj(order.paymentDetail) && order.paymentDetail.paymentType == "Gift Card" ? "glyphicon glyphicon-gift" : "glyphicon glyphicon-credit-card" }),
                                        _react2.default.createElement(
                                            'span',
                                            { className: "ml-5" },
                                            PaymentType
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        'Order:'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        order.orderNum
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        'Placed:'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        Utils.formatDateTimeWithTimeZone(new Date(order.createdAt), this.props.locationDetail.timeZone)
                                    )
                                )
                            ),
                            order.scheduledAt ? _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        'Scheduled:'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        Utils.formatDateTimeWithTimeZone(new Date(order.scheduledAt.iso), this.props.locationDetail.timeZone)
                                    )
                                )
                            ) : null,
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        'Restaurant:'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        this.props.resAddress
                                    )
                                )
                            ),
                            isCurbsidePickupOrder ? _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        dispStr,
                                        ':'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        vColor,
                                        ' ',
                                        vMakeModel
                                    )
                                )
                            ) : null,
                            isDineInEnabled ? _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        dispStr,
                                        ':'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        slData
                                    )
                                )
                            ) : null,
                            isDeliveryOrder ? _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        dispStr,
                                        ':'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        self.getDeliveryAddress()
                                    )
                                )
                            ) : null,
                            order.orderInstructions ? _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        'Instructions:'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        order.orderInstructions
                                    )
                                )
                            ) : null,
                            isUtensilsAndNapkins ? _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-5' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: 'bold' },
                                        'Utensils and Napkins:'
                                    )
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-xs-7' },
                                    _react2.default.createElement(
                                        'h4',
                                        { className: "light-text" },
                                        utensilsAndNapkins
                                    )
                                )
                            ) : null
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'order-state-box' },
                            _react2.default.createElement(
                                'div',
                                { className: 'row' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'col-md-12' },
                                    _react2.default.createElement(
                                        'ul',
                                        { style: { listStyleType: 'disc', paddingRight: '10px' } },
                                        order.orderStateChanges ? order.orderStateChanges.map(function (osChanges, idx) {

                                            var activeState = " li-padding ";
                                            if (osChanges.orderState == order.orderState) {
                                                activeState += "activeState";
                                            }

                                            return _react2.default.createElement(
                                                'li',
                                                { className: activeState, key: '' + order.objectId + idx },
                                                _react2.default.createElement(
                                                    'b',
                                                    null,
                                                    osChanges.orderState
                                                ),
                                                ': ',
                                                Utils.formatDateTimeWithTimeZone(new Date(osChanges.timestamp), _this2.props.locationDetail.timeZone),
                                                _react2.default.createElement('br', null),
                                                osChanges.stateChangedNote
                                            );
                                        }) : null
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return OrderStatus;
}(_react2.default.Component);

exports.default = OrderStatus;


//////////////////
// WEBPACK FOOTER
// ./src/components/order/OrderStatus.jsx
// module id = 545
// module chunks = 0